import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterSheetInterface,
  DamageMultiplierSimple,
} from "@dndModels";
import { DAMAGE_TYPES } from "@dndModels/Constants";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import ImageFromString from "@dndComponents/display/ImageFromString";

interface Props {
  character: Character;
  char_interface: CharacterSheetInterface;
  disabled: boolean;
  onChange: () => void;
}

export default function CharacterDefensesButton({ 
  character,
  char_interface,
  disabled,
  onChange,
}: Props) {
  const [open, setOpen] = useState(false);
  // const [reloading, setReloading] = useState(false);
  const [damage_multipliers, setDamageMultipliers] = useState<DamageMultiplierSimple[]>([]);

  // useEffect(() => {
  //   if (reloading) {
  //     setReloading(false);
  //   }
  // }, [reloading, setReloading]);

  const renderDefensesInput = () => {
    const enabled = !disabled;
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          className="header centered"
          size={{
            xs: 12
          }}>
          Defenses
        </Grid>
        { DAMAGE_TYPES.filter(o => o !== "Typeless" && o !== "Same as Main").map(dmg => {
          // console.log(dmg);
          const multipliers = damage_multipliers.filter(o => o.damage_type === dmg);
          const vuln = multipliers.filter(o => o.multiplier === 2).length > 0;
          const resist = multipliers.filter(o => o.multiplier === 0.5).length > 0;
          const immune = multipliers.filter(o => o.multiplier === 0).length > 0;
          const vuln_ff = multipliers.filter(o => o.multiplier === 2 && o.from_feature).length > 0;
          const resist_ff = multipliers.filter(o => o.multiplier === 0.5 && o.from_feature).length > 0;
          const immune_ff = multipliers.filter(o => o.multiplier === 0 && o.from_feature).length > 0;
          return (
            <Grid
              key={dmg}
              size={{
                xs: 12
              }}>
              <Grid container spacing={0} direction="row">
                <Grid
                  container
                  spacing={0}
                  direction="row"
                  size={{
                    xs: 3
                  }}>
                  <Grid
                    size={{
                      xs: 10
                    }}>
                    { dmg }
                  </Grid>
                  <Grid
                    size={{
                      xs: 2
                    }}>
                    <ImageFromString image={dmg} size={25} color="white" />
                  </Grid>
                </Grid>
                <Grid
                  style={{
                    color: (vuln ? "red" : "darkgray"),
                    fontWeight: (vuln_ff ? "bold" : "normal"),
                    cursor: "pointer", textAlign: "right"
                  }}
                  onClick={() => {
                    if (!vuln_ff && enabled) {
                      if (vuln) {
                        setDamageMultipliers(damage_multipliers.filter(o => o.damage_type !== dmg || o.multiplier !== 2));
                        // character.extra_damage_multipliers = character.extra_damage_multipliers.filter(o => o.damage_type !== dmg || o.multiplier !== 2);
                        character.mind.damage_multipliers = character.damage_multipliers.filter(o => o.damage_type !== dmg || o.multiplier !== 2);
                      } else {
                        const dm = new DamageMultiplierSimple();
                        dm.damage_type = dmg;
                        dm.multiplier = 2;
                        setDamageMultipliers([...damage_multipliers,dm]);
                        // character.extra_damage_multipliers.push(dm);
                        character.mind.damage_multipliers.push(dm);
                      }
                      onChange();
                      // setReloading(true);
                    }
                  }}
                  size={{
                    xs: 3
                  }}>
                  Vulnerable
                </Grid>
                <Grid
                  style={{
                    color: (resist ? "blue" : "darkgray"),
                    fontWeight: (resist_ff ? "bold" : "normal"),
                    cursor: "pointer", textAlign: "right"
                  }}
                  onClick={() => {
                    if (!resist_ff && enabled) {
                      if (resist) {
                        setDamageMultipliers(damage_multipliers.filter(o => o.damage_type !== dmg || o.multiplier !== 0.5));
                        // character.extra_damage_multipliers = character.extra_damage_multipliers.filter(o => o.damage_type !== dmg || o.multiplier !== 0.5);
                        character.mind.damage_multipliers = character.damage_multipliers.filter(o => o.damage_type !== dmg || o.multiplier !== 0.5);
                      } else {
                        const dm = new DamageMultiplierSimple();
                        dm.damage_type = dmg;
                        dm.multiplier = 0.5;
                        setDamageMultipliers([...damage_multipliers,dm]);
                        // character.extra_damage_multipliers.push(dm);
                        character.mind.damage_multipliers.push(dm);
                      }
                      onChange();
                      // setReloading(true);
                    }
                  }}
                  size={{
                    xs: 3
                  }}>
                  Resistant
                </Grid>
                <Grid
                  style={{
                    color: (immune ? "green" : "darkgray"),
                    fontWeight: (immune_ff ? "bold" : "normal"),
                    cursor: "pointer", textAlign: "right"
                  }}
                  onClick={() => {
                    if (!immune_ff && enabled) {
                      if (immune) {
                        setDamageMultipliers(damage_multipliers.filter(o => o.damage_type !== dmg || o.multiplier !== 0));
                        // character.extra_damage_multipliers = character.extra_damage_multipliers.filter(o => o.damage_type !== dmg || o.multiplier !== 0);
                        character.mind.damage_multipliers = character.damage_multipliers.filter(o => o.damage_type !== dmg || o.multiplier !== 0);
                      } else {
                        const dm = new DamageMultiplierSimple();
                        dm.damage_type = dmg;
                        dm.multiplier = 0;
                        setDamageMultipliers([...damage_multipliers,dm]);
                        // character.extra_damage_multipliers.push(dm);
                        character.mind.damage_multipliers.push(dm);
                      }
                      onChange();
                      // setReloading(true);
                    }
                  }}
                  size={{
                    xs: 3
                  }}>
                  Immune
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    );
  }

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        className={`centered header ${ disabled ? "" : "clickable"}`}
        onClick={() => {
          if (!disabled) {
            setDamageMultipliers(char_interface.mind.damage_multipliers.map(o => o.clone()));
            setOpen(true);
          }
        }}
        size={{
          xs: 12
        }}>
        Defenses
      </Grid>
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
        }}>
        { open && renderDefensesInput() }
      </ModalOrDrawer>
    </Grid>
  );
}
